/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown> }} CopyrightInputs */

const en_copyright = /** @type {(inputs: CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© 2023 - ${i?.year} Dutch Passion Thailand`)
};

const th_copyright = /** @type {(inputs: CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© 2023 - ${i?.year} Dutch Passion Thailand`)
};

const ja_copyright = /** @type {(inputs: CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© 2023 - ${i?.year} Dutch Passion Thailand`)
};

const fr_copyright = /** @type {(inputs: CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© 2023 - ${i?.year} Dutch Passion Thailand`)
};

const es_copyright = /** @type {(inputs: CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© 2023 - ${i?.year} Dutch Passion Thailand`)
};

const ru_copyright = /** @type {(inputs: CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© 2023 - ${i?.year} Dutch Passion Thailand`)
};

const zh_copyright = /** @type {(inputs: CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© 2023 - ${i?.year} Dutch Passion Thailand`)
};

const vi_copyright = /** @type {(inputs: CopyrightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`© 2023 - ${i?.year} Dutch Passion Thailand`)
};

/**
* | output |
* | --- |
* | "© 2023 - {year} Dutch Passion Thailand" |
*
* @param {CopyrightInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const copyright = /** @type {((inputs: CopyrightInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CopyrightInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_copyright(inputs)
	if (locale === "ja") return ja_copyright(inputs)
	if (locale === "fr") return fr_copyright(inputs)
	if (locale === "es") return es_copyright(inputs)
	if (locale === "ru") return ru_copyright(inputs)
	if (locale === "zh") return zh_copyright(inputs)
	if (locale === "vi") return vi_copyright(inputs)
	return en_copyright(inputs)
});